import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { NOTIFICATION_SERVICE } from '@eggplant/api-hosts'
import type { ReactElement } from 'react'

interface Props {
  children?: () => ReactElement
}

const PingNotificationService = ({
  children
}: Props) => {
  const url = `${NOTIFICATION_SERVICE}/health/ready`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      url={url}
    />
  )
}

export default PingNotificationService
